import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SelectReact from "react-select";
import AsyncSelect from "react-select/async";
import { useDropzone } from "react-dropzone";

const InputValidation = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  autocomplete,
}) => {
  return (
    <div
      className={
        errors[name] && touched[name] ? "form-group has-danger" : "form-group"
      }
    >
      <div className="input-group input-group-merge">
        <div className="input-group-prepend">
          <span className="input-group-text">
            {" "}
            <i className={icon} />{" "}
          </span>
        </div>
        <input
          asp-for={name}
          type={type}
          placeholder={placeholder ? placeholder : ""}
          className={
            errors[name] && touched[name]
              ? "form-control is-invalid"
              : "form-control"
          }
          value={value}
          onChange={(e) => onChange(e)}
        />
        {errors[name] && touched[name] ? (
          <div className="invalid-feedback">{errors[name]}</div>
        ) : null}
      </div>
    </div>
  );
};

// non validation

const InputLabel = ({ label, name, onChange, value, placeholder, type }) => {
  return (
    <div className="form-group row">
      <label
        htmlFor="example-text-input"
        className="col-md-2 col-form-label form-control-label"
      >
        {label}
      </label>
      <div className="col-md-10">
        <input
          className="form-control"
          value={value}
          type={type}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
// tipe Data Date,
const InputValidationSm = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  autocomplete,
}) => {
  return (
    <div
      className={
        errors[name] && touched[name]
          ? "form-group has-danger focused"
          : "form-group"
      }
    >
      <div className="row col-md-12">
        <div className="col-md-4">
          <label className="form-control-label">{label}</label>
        </div>
        <div className="col-md-8">
          <input
            asp-for={name}
            type={type}
            placeholder={placeholder ? placeholder : ""}
            className={
              errors[name] && touched[name]
                ? "form-control is-invalid"
                : "form-control form-control-sm"
            }
            value={value}
            name={name}
            onChange={(e) => onChange(e)}
            autoComplete={autocomplete}
          />
          {errors[name] && touched[name] ? (
            <div className="invalid-feedback">{errors[name]}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const TextArea = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  row,
  type,
  label,
  autocomplete,
}) => {
  return (
    <div
      className={
        errors[name] && touched[name]
          ? "form-group has-danger focused"
          : "form-group"
      }
    >
      <div className="row col-md-12">
        <div className="col-md-4">
          <label className="form-control-label">{label}</label>
        </div>
        <div className="col-md-8">
          <textarea
            className="form-control"
            placeholder={placeholder ? placeholder : ""}
            className={
              errors[name] && touched[name]
                ? "form-control is-invalid"
                : "form-control form-control-sm"
            }
            value={value}
            name={name}
            onChange={(e) => onChange(e)}
            autoComplete={autocomplete}
            row={row}
          />

          {errors[name] && touched[name] ? (
            <div className="invalid-feedback">{errors[name]}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const DatePickerX = (props) => {
  // const [startDate, setStartDate] = useState(new Date());
  return (
    <DatePicker
      className={props.class}
      selected={props.startDate}
      onChange={(date) => props.setStartDate(date)}
      // timeInputLabel="Time:"
      dateFormat="dd/MM/yyyy"
    // showTimeInput
    />
  );
};

const Select = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  option,
  className = 'form-control form-control-sm'
}) => {
  return (
    <div
      className={
        errors[name] && touched[name] ? "form-group has-danger" : "form-group"
      }
    >
      <div className="row col-md-12">
        {label ?
          <div className="col-md-4">
            <label className="form-control-label" htmlFor={name}>
              {label}
            </label>
          </div>
          : ''}
        <div className={label ? "col-md-8" : "col-md-12"} >
          <select
            className={
              errors[name] && touched[name]
                ? "form-control is-invalid"
                : className
            }
            name={name}
            id={name}
            value={value}
            onChange={(e) => onChange(e)}
          >
            <option value="">== Pilih Data ==</option>
            {option?.map((data, key) => (
              <option value={data.id} key={key}>
                {data.name}
              </option>
            ))}
          </select>
          {errors[name] && touched[name] ? (
            <div className="invalid-feedback">{errors[name]}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const ToggleInput = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  option,
}) => {
  return (
    <div
      className={
        errors[name] && touched[name] ? "form-group has-danger" : "form-group"
      }
    >
      <div className="row col-md-12">
        <div className="col-md-4">
          <label className="form-control-label" htmlFor={name}>
            {label}
          </label>
        </div>
        <div className="col-md-8">
          <label className="custom-toggle">
            <input
              type="checkbox"
              name={name}
              onChange={(e) => onChange(e)}
              checked={parseInt(value) > 0 ? true : false}
            />
            <span
              className="custom-toggle-slider rounded-circle"
              data-label-off={option.off}
              data-label-on={option.on}
            ></span>
          </label>
        </div>
      </div>
    </div>
  );
};

const Select2 = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  option,
  isMulti,
}) => {
  return (
    <div
      className={
        errors[name] && touched[name] ? "form-group has-danger" : "form-group"
      }
    >
      <div className="row col-md-12">
        <div className="col-md-4">
          <label className="form-control-label" htmlFor={name}>
            {label}
          </label>
        </div>
        <div className="col-md-8">
          <SelectReact
            defaultValue={value}
            isMulti={isMulti ? isMulti : false}
            onChange={onChange}
            name={name}
            options={option}
            className="basic-multi-select"
            classNamePrefix="select"
          />
          {errors[name] && touched[name] ? (
            <div className="invalid-feedback">{errors[name]}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const Select2Nolabel = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  className = 'basic-multi-select form-control  p-0 pt-1',
  option,
  isMulti,
}) => {
  return (
    <SelectReact
      defaultValue={value}
      isMulti={isMulti ? isMulti : false}
      onChange={onChange}
      name={name}
      options={option}
      // className="basic-multi-select"
      classNamePrefix="select"
      className={className}
      styles={{
        control: (styles) => ({
          ...styles,
          backgroundColor: "white",
          border: "none",
        }),
        menu: (styles) => ({
          ...styles,
          zIndex: 9999, // Set the desired z-index value
        }),
      }}
    />
  );
};

const SelectAsync = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  icon,
  type,
  label,
  loadOptions,
  onInputChange,
  isMulti = false,
}) => {
  return (
    <div
      className={
        errors[name] && touched[name] ? "form-group has-danger" : "form-group"
      }
    >
      <div className="row col-md-12">
        <div className="col-md-4">
          <label className="form-control-label" htmlFor={name}>
            {label}
          </label>
        </div>
        <div className="col-md-8">
          <AsyncSelect
            defaultValue={value}
            isMulti={isMulti}
            onChange={onChange}
            name={name}
            cacheOptions
            loadOptions={loadOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            onInputChange={onInputChange}
          />
          {errors[name] && touched[name] ? (
            <div className="invalid-feedback">{errors[name]}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const DropZone = ({
  name,
  onChange,
  value,
  placeholder,
  errors,
  touched,
  label,
  autocomplete,
}) => {
  // const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      onChange(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = value.map((file) => (
    // <div style={thumb} key={file.name}>
    //     <div style={thumbInner}>
    <img src={file.preview} className={"dz-preview-img"} />
    //     </div>
    // </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      value.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [value]
  );

  return (
    <div
      className={
        errors[name] && touched[name]
          ? "form-group has-danger focused"
          : "form-group"
      }
    >
      <div className="row col-md-12">
        <div className="col-md-4">
          <label className="form-control-label">{label}</label>
        </div>
        <div className="col-md-8">
          {value.length > 0 ? (
            <div className="row align-items-center">
              <div className="col-8">{/* Title */}</div>
              <div className="col-4 text-right">
                <a
                  onClick={() => onChange([])}
                  className="btn btn-sm btn-danger text-white"
                >
                  clear
                </a>
              </div>
            </div>
          ) : (
            ""
          )}
          <div
            className={
              value.length > 0
                ? "dropzone dropzone-single mb-3 dz-clickable dz-max-files-reached"
                : "dropzone dropzone-single mb-3 dz-clickable"
            }
            data-toggle="dropzone"
            data-dropzone-url="http://"
          >
            <div className="dz-preview dz-preview-single">
              <div className="dz-preview-cover dz-processing dz-image-preview">
                {thumbs}
              </div>
            </div>
            <div {...getRootProps({ className: "dz-default dz-message" })}>
              <input {...getInputProps()} />
              <span>Drag 'n' drop images here, or click to select files</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export {
  InputValidation,
  ToggleInput,
  InputLabel,
  InputValidationSm,
  DatePickerX,
  Select,
  TextArea,
  Select2,
  SelectAsync,
  DropZone,
  Select2Nolabel
};
